import { BEFORE_EXPLORE, GET_EXPLORE, SET_EXPLORE_ID, BEFORE_SET_ID, SET_ALL, BEFORE_ALL } from '../../../redux/types';

const initialState = {
    nfts: null,
    nftsAuth: false,
    navAuth: false,
    catId: null,
    allAuth: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_EXPLORE:
            return {
                ...state,
                nfts: action.payload,
                nftsAuth: true
            }
        case SET_EXPLORE_ID:
            return {
                ...state,
                catId: action.payload,
                navAuth: true
            }
        case SET_ALL:
            return{
                ...state,
                allAuth: true
            }
        case BEFORE_ALL: 
            return{
                ...state,
                allAuth: false
            }
        case BEFORE_EXPLORE:
            return {
                ...state,
                nfts: null,
                nftsAuth: false
            }
        case BEFORE_SET_ID:
            return {
                ...state,
                navAuth: false,
                catId: null
            }
        default:
            return {
                ...state
            }
    }
}